/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import scoreService from '../../services/score'

const initialState = {
  scores: null,
  timeline: null,
}

export const getScores = createAsyncThunk(
  'score/getScores',
  scoreService.getScores
)

export const getScoreTimeline = createAsyncThunk(
  'score/getScoreTimeline',
  scoreService.getScoreTimeline
)

const score = createSlice({
  name: 'score',
  initialState,
  reducers: {},
  extraReducers: {
    [getScores.pending]: (state) => {
      state.scores = null
    },
    [getScores.fulfilled]: (state, action) => {
      const { data } = action.payload

      state.scores = data
    },
    [getScoreTimeline.pending]: (state) => {
      state.timeline = null
    },
    [getScoreTimeline.fulfilled]: (state, action) => {
      const { data } = action.payload

      state.timeline = data
    },
  },
})

export default score.reducer
